import { format, isToday, isYesterday } from "date-fns";
import { it } from "date-fns/locale";

export const initials = (name = "") =>
  name.split(" ").filter(Boolean).slice(0, 2).map((p) => p[0]?.toUpperCase()).join("") || "?";

export const listTime = (iso) => {
  const d = new Date(iso);
  if (isToday(d)) return format(d, "HH:mm");
  if (isYesterday(d)) return "Ieri";
  return format(d, "dd/MM/yy");
};

export const bubbleTime = (iso) => format(new Date(iso), "HH:mm", { locale: it });
export const dayLabel = (iso) => {
  const d = new Date(iso);
  if (isToday(d)) return "Oggi";
  if (isYesterday(d)) return "Ieri";
  return format(d, "EEEE d MMMM", { locale: it });
};

export const duration = (s) => {
  if (!s) return "0m";
  if (s < 60) return `${s}s`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m}m ${s % 60}s`;
  return `${Math.floor(m / 60)}h ${m % 60}m`;
};
